import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { view } from '@risingstack/react-easy-state'
import StyledBox from 'components/common/styled-components/StyledBox'
import globalStore from 'store/index'
import dayjs from 'dayjs'

import BudgetCriteriaHeadsService from 'services/users/budget-criteria-heads.service'
import BudgetHeadsService from 'services/users/budget-heads.service'
import { Select, message, Button } from 'antd'
import { Redirect } from 'react-router-dom'
import BudgetApprovalWorkFlowForm from 'components/BudgetApprovalWorkFlowForm'
import EmailTemplatesService from 'services/users/email-templates.service'

const localizedFormat = require('dayjs/plugin/localizedFormat')
dayjs.extend(localizedFormat)

const StyledPageContent = styled.div`
	& > .action-buttons.top {
		display: flex;
		justify-content: flex-end;
		margin-bottom: 20px;
	}
`

const BudgetApprovalWorkflow = () => {
	const [budgetHead, setBudgetHead] = useState()
	const [budgetHeads, setBudgetHeads] = useState([])
	const [budgetHeadId, setBudgetHeadId] = useState()

	const recordTypes = [
		{ name: 'Planned Value', id: 1 },
		{ name: 'Actual Value', id: 2 },
	]
	const [recordType, setRecordType] = useState(recordTypes[0])

	useEffect(() => {
		const pageState = globalStore.ui.configuration.budgetCriteriaHeads.criteria_head_list

		const fetchAllFieldsData = async () => {
			await BudgetCriteriaHeadsService.criteriaHeadList({ pageState })
			const { budget_criteria_heads } = pageState

			if (!budget_criteria_heads) {
				message.error('Budget criteria not found')
				return
			}
		}

		fetchAllFieldsData()
	}, [])

	useEffect(() => {
		const pageState = globalStore.ui.configuration.budgetHeads.index

		const fetchBudgetHeads = async () => {
			await BudgetHeadsService.index({ pageState })
			const { budget_heads } = pageState

			if (!budget_heads) {
				message.error('Budget Heads not found')
				return
			}
			setBudgetHeads(budget_heads)
			setBudgetHead(
				budget_heads.some((value) => value.name === 'Workforce Plan')
					? budget_heads.find((value) => value.name === 'Workforce Plan')?.name
					: budget_heads[0]?.name
			)
			setBudgetHeadId(
				budget_heads.some((value) => value.name === 'Workforce Plan')
					? budget_heads.find((value) => value.name === 'Workforce Plan')?.id
					: budget_heads[0]?.id
			)
		}

		fetchBudgetHeads()
	}, [])

	const handleDropDownChange = (value, inputType) => {
		if (inputType === 'record_type') {
			setRecordType(recordTypes.find((rt) => rt.name === value))
			return
		}
		if (inputType === 'budget_heads') {
			setBudgetHead(value)
			setBudgetHeadId(budgetHeads.find((bh) => bh.name === value)?.id)
		}
	}

	const handleCreateDefaultBudgetApprovalTemplate = async () => {
		const tempState = {}
		await EmailTemplatesService.createDefaultBudgetApprovalTemplate({ pageState: tempState })
		const { message: messages, errors } = tempState
		if (errors) {
			message.error(errors[0] || 'Budget Approval Template could not be created.')
			return
		}
		message.success(messages || 'Budget Approval Template created successfully!')
	}

	const renderPageContent = () => {
		return (
			<StyledPageContent>
				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'baseline',
						marginTop: '25px',
					}}>
					<span style={{ fontSize: '1.5em', fontWeight: 'bold' }}>Budget Approval</span>
					<Button type='link' onClick={handleCreateDefaultBudgetApprovalTemplate}>
						Create Default Budget Approval Template
					</Button>
				</div>
				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'baseline',
						marginTop: '25px',
					}}>
					<div
						style={{
							marginTop: '5px',
							display: 'flex',
							justifyContent: 'start',
							alignItems: 'center',
						}}>
						<div style={{ marginRight: '5px' }}> Approval For </div>
						<div>
							<Select
								style={{ minWidth: '260px' }}
								defaultValue={recordTypes[0]?.name}
								onChange={(e) => handleDropDownChange(e, 'record_type')}>
								{recordTypes.map((rt) => (
									<Select.Option key={rt.id} value={rt.name} title={rt.name}>
										{rt.name}
									</Select.Option>
								))}
							</Select>
						</div>
					</div>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
						}}>
						<div style={{ marginRight: '10px' }}>Budget Head</div>
						<div>
							<Select
								showSearch
								style={{ minWidth: '260px' }}
								value={budgetHead}
								optionLabelProp='label'
								onChange={(e) => handleDropDownChange(e, 'budget_heads')}>
								{budgetHeads.map((bh) => (
									<Select.Option key={bh.id} value={bh.name} title={bh.name}>
										{bh.display_name}
									</Select.Option>
								))}
							</Select>
						</div>
					</div>
				</div>
				<div>
					<BudgetApprovalWorkFlowForm
						budgetHeadId={budgetHeadId}
						budgetHead={budgetHead}
						recordType={recordType}
					/>
				</div>
			</StyledPageContent>
		)
	}

	const accessibleFeatures = globalStore.currentUser?.accessible_features || []

	if (
		accessibleFeatures?.length &&
		!['smart-budget', 'criteria-edit', 'budget-data-edit'].every((featureKey) =>
			accessibleFeatures.includes(featureKey)
		)
	)
		return <Redirect to='/' />

	return (
		<div className='page-content budget_values_approval-page'>
			<StyledBox>
				<div>{renderPageContent()}</div>
			</StyledBox>
		</div>
	)
}

export default view(BudgetApprovalWorkflow)
